angular.module('myApp.directives')
    .directive('audioVideoResponseWindow', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs, socket) {
            },
            controller: function ($scope, $element, $attrs, $transclude, audioVideoResponseWindowMobile) {
                $scope.audioVideoQId    = null;
                $scope.setAudioVideoQId  = function(qId) {
                    if (qId) {
                        $scope.audioVideoQId = parseInt(qId);
                    } else {
                        $scope.audioVideoQId = null;
                    }
                    $scope.avOptions = audioVideoResponseWindowMobile.getAVOptions();
                };
            }
        }
    });